import React from "react";
import "./AboutPage.css";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";


const AboutPage: React.FC = () => {
  const heroBg = process.env.PUBLIC_URL + "/images/HERO3.jpg";

  const teamMembers = [
    {
      name: "Mohammad Omar",
      image: "/images/profiles/Omar-profile.webp",
      linkedin:
        "https://www.linkedin.com/in/mohamad-omar-b092a290?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      title: "Co-founder | Senior Architect",
    },
    {
      name: "Mohammad Ramadan",
      image: "/images/profiles/Mohamad-profile.webp",
      linkedin:
        "https://www.linkedin.com/in/mohamad-ramadan-6782b566?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      title: "Partner | Senior Architect",
    },
    {
      name: "Waref Sleiman",
      image: "/images/profiles/Waref-profile.webp",
      linkedin:
        "https://www.linkedin.com/in/waref-sleiman-900b3a2b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      title: "Partner | Senior Architect",
    },
    {
      name: "Ghida Fayek",
      image: "/images/profiles/Ghida-profile.webp",
      linkedin:
        "https://www.linkedin.com/in/ghida-fayek-03aa5a10b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      title: "Senior Architect",
    },
    {
      name: "Abbas Zaarour",
      image: "/images/profiles/Abbas-profile.webp",
      linkedin:
        "https://www.linkedin.com/in/abbas-zaarour-9068b278?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      title: "Architect",
    },
    {
      name: "Reem Ayoub",
      image: "/images/profiles/Reem-profile.webp",
      linkedin:
        "https://www.linkedin.com/in/reemayoub?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      title: "Architect",
    },
  ];

  return (
    <>
      {/* Hero */}
      <section
        className="about-hero"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="about-hero-overlay">
          <h1 className="about-title">Experts ready to serve !</h1>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="team-container">
          {teamMembers.map((member, index) => (
            <div className="team-card" key={index}>
              <div className="team-photo-wrapper">
                <img
                  src={member.image}
                  alt={member.name}
                  className="team-photo"
                />
                <div className="hover-overlay">{member.title}</div>
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="linkedin-badge"
                >
                  <i className="fab fa-linkedin-in" />
                </a>
              </div>

              <p className="team-name">{member.name}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="services-header">
          <p className="services-subtitle">Services</p>
          <h2 className="services-title">This is what we do.</h2>
        </div>
        <div className="services-cards">
          <div className="service-card">
            <i className="fas fa-sitemap service-icon"></i>
            <h3 className="service-title">Planning</h3>
            <p className="service-desc">
              Our master plans provide a comprehensive look at where an
              organization is today.
            </p>
            <div className="button-wrapper">
              <span className="line"></span>
              <Link to="/planning" className="button hero-button">READ</Link>
              <span className="line"></span>
            </div>
          </div>
          <div className="service-card">
            <i className="fas fa-lightbulb service-icon"></i>
            <h3 className="service-title">Interior</h3>
            <p className="service-desc">
              You may engage your architect to provide an interior design
              service, advising on loose furniture.
            </p>
            <div className="button-wrapper">
              <span className="line"></span>
              <Link to="/interior" className="button hero-button">READ</Link>
              <span className="line"></span>
            </div>
          </div>
          <div className="service-card">
            <i className="fas fa-layer-group service-icon"></i>
            <h3 className="service-title">Exterior</h3>
            <p className="service-desc">
              Working together with your architect, you will share your project
              needs, dreams and goals.
            </p>
            <div className="button-wrapper">
              <span className="line"></span>
              <Link to="/exterior" className="button hero-button">READ</Link>
              <span className="line"></span>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default AboutPage;
